import type { FC } from 'react';

import Accordion from 'components/accordion/Accordion';
import DateCardTagsItem from './DateCardTagsItem';

import { IDateCardTags } from 'source/NFR.types';

const DateCardTags: FC<IDateCardTags> = ({ accordion, items = [], numberOfVisibleItems = 4 }) => {
  if (!accordion) {
    return (
      <div className="date-card-tags">
        {items?.map(item => (
          <DateCardTagsItem key={item.id} {...item} />
        ))}
      </div>
    );
  }

  const visibleItems = items.slice(0, numberOfVisibleItems);
  const hiddenItems = items.slice(numberOfVisibleItems);

  return (
    <div className="date-card-tags">
      {visibleItems?.map(item => (
        <DateCardTagsItem key={item.id} {...item} />
      ))}
      {hiddenItems?.length > 0 && (
        <Accordion animate={false} showButtonText={true} {...accordion}>
          {({ Button: AccordionButton, Collapse }) => (
            <>
              <Collapse>
                {hiddenItems.map(item => (
                  <DateCardTagsItem key={item.id} {...item} />
                ))}
              </Collapse>

              <div className="date-card-tags-item">
                <AccordionButton className="date-card-tags-button" theme="link" />
              </div>
            </>
          )}
        </Accordion>
      )}
    </div>
  );
};

DateCardTags.displayName = 'DateCardTags';

export default DateCardTags;
